module.exports = __webpack_public_path__ + "img/image-88.b11b09d8.jpg";